import {Component, h} from 'preact'
import GroupDescription from './GroupDescription'
import Axios from 'axios'
import GroupActionButtons from './GroupActionButtons'
import GroupMembers from './GroupMembers'
import TopicListItemView, {TopicInfo} from '../topic-list-view/TopicListItemView'
import TopicListItem from '../topic-list-view/TopicListItem'
import {common} from '../common'
import {UserData} from '../event/EventAttendees'

export interface GroupData {
  id: number,
  title: string,
  description: string
}

interface Props {
  group: GroupData,
  csrfToken: string,
  topics: Array<TopicInfo>,
  attachmentCdn: string,
  isGuest: boolean,
  members: Array<UserData>,
  isCurrentUserMember: boolean
}

interface State {
  userJoined: boolean,
  isLoading: boolean
}

export class Group extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      userJoined: props.isCurrentUserMember,
      isLoading: false
    }

    this.joinGroup = this.joinGroup.bind(this)
    this.leaveGroup = this.leaveGroup.bind(this)
  }

  async joinGroup() {
    if (!window.inSidedData.user.userid) {
      const event = new window.CustomEvent('GuestUserAction')
      window.dispatchEvent(event)
      return
    }

    this.setState({isLoading: true})

    try {
      await Axios.post(`/group/${this.props.group.id}/join`, {csrfToken: this.props.csrfToken})
      this.setState({userJoined: true, isLoading: false})
    } catch (e) {
      this.setState({isLoading: false})
    }
  }

  async leaveGroup() {
    this.setState({isLoading: true})

    try {
      await Axios.post(`/group/${this.props.group.id}/leave`, {csrfToken: this.props.csrfToken})
      this.setState({userJoined: false, isLoading: false})
    } catch (e) {
      this.setState({isLoading: false})
    }
  }
  render({group, topics, isGuest, attachmentCdn, members}: Props, {userJoined, isLoading}: State) {
    const {description} = group
    const isNewTopicListViewEnabled = common.isModuleActive('topicItemView')

    return (
      <div className='group-detail-wrapper'>
        <GroupActionButtons
          joinGroup={this.joinGroup}
          leaveGroup={this.leaveGroup}
          isLoading={isLoading}
          isUserMember={userJoined}
          groupId={group.id}
        />
        <div className='sitewidth group-detail'>
          <div className='col col--main has--side qa-div-main'>
            <div className='box'>
              {
                topics.map(topic => {
                  return isNewTopicListViewEnabled ? (
                    <TopicListItemView
                      topic={topic}
                      isGuest={isGuest}
                      attachmentCdn={attachmentCdn}
                      hideCategoryMetadata
                    />
                  ) : (
                    <TopicListItem
                      tab={0}
                      topic={topic}
                      isGuest={isGuest}
                      attachmentCdn={attachmentCdn}
                    />
                  )
                })}
            </div>
          </div>
          <div className='col col--side Sidebarmodule qa-div-sidebar'>
            <GroupDescription description={description} />
            <GroupMembers members={members} />
          </div>
        </div>
      </div>
    )
  }
}

export default Group
